// extracted by mini-css-extract-plugin
export default {"_hy":"_hy","itemList":"suggestion-module_itemList_Say","category":"suggestion-module_category_-dc","lastCategory":"suggestion-module_lastCategory_3X3"};